import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

interface Props {
  text: string | undefined;
}

export const Overlay = ({ text }: Props) => {
  if (!text) return null;
  return (
    <div
      className={center({
        pos: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 'modal',
        flexDirection: 'column',
        color: 'content.accent.info',
        bg: 'gray.black/80',
      })}
    >
      <div
        className={css({
          pos: 'relative',
          textStyle: 'Display/L',
          bgColor: 'gray.300',
          rounded: '50%',
          transform: 'rotate(-15deg)',
          _before: {
            content: "''",
            rounded: '50%',
          },
          tabletDown: {
            p: '18px 30px',
            mb: 12,
            _before: {
              position: 'absolute',
              top: 2,
              right: 8,
              bottom: 2,
              left: 8,
              borderWidth: '2px',
              borderStyle: 'solid',
              borderColor: 'background.accent.primary',
            },
          },
          tablet: {
            p: '38px 60px',
            mb: 30,
            _before: {
              position: 'absolute',
              top: 4,
              right: 12,
              bottom: 4,
              left: 12,
              borderWidth: '3px',
              borderStyle: 'solid',
              borderColor: 'background.accent.primary',
            },
          },
        })}
      >
        <FormattedMessage id='Autogen_common.r251126.s_Closed' />
      </div>
      <p className={css({ textStyle: 'Text/L/Strong', m: '0 20px', textAlign: 'center', whiteSpace: 'pre-wrap' })}>
        {text}
      </p>
    </div>
  );
};
